import { render, staticRenderFns } from "./LocatieInformatieContent.vue?vue&type=template&id=84605778&"
import script from "./LocatieInformatieContent.vue?vue&type=script&lang=js&"
export * from "./LocatieInformatieContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports